/* ============================================================
   <surisa-collections-index> — vista de colecciones (/collections)
   ------------------------------------------------------------
   Desktop (≥990px): grupos siempre expandidos (sin interacción).
   Mobile  (<990px): acordeón (primer grupo abierto; el resto colapsado).
   Progressive enhancement: sin JS, todos los grupos quedan visibles
   (el markup se sirve expandido por defecto).
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 989px)';

  customElements.define(
    'surisa-collections-index',
    class SurisaCollectionsIndex extends HTMLElement {
      connectedCallback() {
        this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-ci-group]'));
        this.mq = window.matchMedia(MOBILE_MQ);

        this._bindToggles();

        this._onMqChange = this._applyMode.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this._onMqChange);
        else if (this.mq.addListener) this.mq.addListener(this._onMqChange);

        this._applyMode();
      }

      disconnectedCallback() {
        if (this.mq) {
          if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._onMqChange);
          else if (this.mq.removeListener) this.mq.removeListener(this._onMqChange);
        }
      }

      _applyMode() {
        if (this.mq.matches) {
          // Móvil: colapsa todos menos el primero.
          this.groups.forEach(function (g, i) {
            this._setCollapsed(g, i !== 0);
          }, this);
        } else {
          // Desktop: todos expandidos.
          this.groups.forEach(function (g) {
            this._setCollapsed(g, false);
          }, this);
        }
      }

      _setCollapsed(group, collapsed) {
        group.classList.toggle('is-collapsed', collapsed);
        var toggle = group.querySelector('.ci-group__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }

      _bindToggles() {
        this.groups.forEach(function (group) {
          var toggle = group.querySelector('.ci-group__toggle');
          if (!toggle) return;
          toggle.addEventListener('click', function () {
            // Solo actúa como acordeón en móvil; en desktop no hace nada.
            if (!this.mq.matches) return;
            this._setCollapsed(group, !group.classList.contains('is-collapsed'));
          }.bind(this));
        }, this);
      }
    }
  );
})();
